import { useNavigate } from "react-router-dom";
import Faq from "../../FAQ/faq";

const SolarPanel = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <div
        className="w-full flex justify-center items-center text-white font-bold px-4 bg-cover bg-center min-h-[220px] md:min-h-[280px] py-10 md:py-16"
        style={{
          backgroundImage: `url(/banner.png)`,
        }}
      >
        <div className="text-center  max-w-[95%] sm:max-w-[80%] md:max-w-[60%] px-2">
          {/* Heading */}
          <h1 className="text-brand-green text-2xl sm:text-3xl md:text-7xl leading-snug sm:leading-normal">
            Power Your Future with High-Efficiency Solar Panels
          </h1>
          {/* Paragraph */}
          <p className="text-sm sm:text-base md:text-lg mt-4 text-black leading-relaxed">
            At Kyra Green Energy Solution, we bring you high-performance solar panels from trusted brands to ensure maximum energy generation, long-term durability, and cost savings. Whether you need panels for your home, business, or large-scale projects, we have the right solution for you.
          </p>
        </div>
      </div>


      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                Our Solar Panel Range
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                We Are Proud Distributors Of Fujiyama, Eastman, And Addos Solar, Offering A Wide Variety Of Solar Panels To Suit Different Requirements. Our Portfolio Includes:
              </p>
              <div className="space-y-3">
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    Premium 720W High-Efficiency Panels – Designed For Maximum Power Generation
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Mono-Crystalline Panels – Highly Efficient And Sleek Design
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Poly-Crystalline Panels – Reliable And Cost-Effective
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Half-Cut Panels – Advanced Technology For Better Performance In Shaded Conditions
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Bifacial Panels – Dual-Sided Energy Capture For Higher Output
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    Utility Scale Panels – For Large Commercial And Industrial Projects
                  </li>
                </ul>
              </div>

              <div className="mt-6">
                <button
                  className="px-6 py-3 text-white font-semibold rounded shadow bg-brand-green"
                  onClick={handleClick}

                >
                  Request a Quote
                </button>
              </div>
            </div>

            <div className="">
              <img
                src="/solar-panel-stack.png"
                alt="Solar Panel Range"
              />
            </div>
          </div>
        </div>
      </section>


      <section
        aria-labelledby="highlight-720w-title"
        className="mx-auto max-w-6xl px-4 py-12"
      >
        <div className="text-center">
          <h2
            id="highlight-720w-title"
            className="text-3xl md:text-4xl font-bold text-brand-green"
          >
            Highlight: 720W Solar Panels
          </h2>

          <p className="mt-4 text-sm md:text-base text-gray-700 leading-relaxed max-w-3xl mx-auto">
            Our 720W panels are engineered for high efficiency and superior performance,
            making them ideal for projects where maximum output is critical. With their
            advanced cell design and durability, these panels deliver consistent energy
            generation even under challenging conditions.
          </p>

          <p className="mt-8 text-xs uppercase tracking-widest text-gray-500">
            Key Benefits
          </p>
        </div>

        {/* Benefits */}
        <div className="mt-6 grid gap-6 md:grid-cols-3">
          {/* Card 1 */}
          <div className="rounded-2xl  bg-white p-6 shadow-sm">
            <div className=" flex items-center justify-center ">
              <img
                src="/solar-battery-icon.png"
                alt="Maximum Power"
              />
            </div>
            <h3 className="mt-4 text-base font-semibold text-gray-900 text-center">
              Maximum power per panel for reduced space usage
            </h3>
          </div>

          {/* Card 2 */}
          <div className="rounded-2xl  bg-white p-6 shadow-sm">
            <div className=" flex items-center justify-center ">
              <img
                src="/solar-panel-icon.png"
                alt="High Efficiency"
              />
            </div>
            <h3 className="mt-4 text-base font-semibold text-gray-900 text-center">
              Long-lasting performance with high efficiency
            </h3>
          </div>

          {/* Card 3 */}
          <div className="rounded-2xl  bg-white p-6 shadow-sm">
            <div className=" flex items-center justify-center ">
              <img
                src="/solar-factory-icon.png"
                alt="Industrial Use"
              />
            </div>
            <h3 className="mt-4 text-base font-semibold text-gray-900 text-center">
              Ideal for industrial, commercial, and utility-scale applications
            </h3>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-8 flex justify-center">
          <button
            onClick={handleClick}
            className="inline-flex items-center rounded-lg bg-brand-green px-6 py-3 text-white font-semibold shadow hover:bg-brand-green focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2"
          >
            Talk to Our Sales Team
          </button>

        </div>
      </section>

      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                Special Solar Combo Package
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                For Those Looking For A Complete Setup, We Also Provide Our 6kW Solar Combo:
              </p>
              <div className="space-y-3 mb-6">
                <h3 className="font-semibold">
                  Includes:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    9 x 720W Solar Panels
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    1 x 6kW Hybrid Inverter
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    1 x 15.2V Lithium Battery (Approx. 5kWh)
                  </li>
                </ul>
              </div>
              <div className="space-y-3 mb-6">
                <h3 className="font-semibold">
                  Pricing:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    Distributors: ₹2,00,000 + GST Per Set (Min. 10 Sets)
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    Dealers: ₹2,20,000 + GST Per Set (Min. 3 Sets)
                  </li>
                </ul>
              </div>
              <button
                className="text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors bg-brand-green"
                onClick={handleClick}
              >
                Talk To Our Sales Team
              </button>
            </div>
            <div className="">
              <img
                src="/solar-power-boards-1.png"
                alt="Solar Panel"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-brand-green">
                Why Choose Our Solar Panels?
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Kyra Green Energy Solution Is More Than A Distributor — We’re Your Partner In Clean Energy.
              </p>
              <ul className="space-y-4 text-gray-700">
                {[
                  "Trusted Brands: Fujiyama, Eastman, And Addos Solar",
                  "Exclusive 720W High-Performance Panels",
                  "Panels Tested For Quality, Durability, And Consistent Performance",
                  "Suitable For Residential, Commercial, And Industrial Use",
                  "Backed By Warranty And After-Sales Service",
                ].map((text, i) => (
                  <li key={i} className="flex items-start">
                    <span className="mr-3 mt-1">•</span>
                    <span>{text}</span>
                  </li>
                ))}
              </ul>
              <button
                className="mt-8 text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors bg-brand-green"
                onClick={handleClick}
              >
                Get a Free Consultation
              </button>
            </div>
            <div className="">
              <img
                src="/solar-panel-with-sun.png"
                alt="Solar Installation"
              />
            </div>
          </div>
        </div>
      </section>
      <Faq type="panel" />

    </>
  );
};

export default SolarPanel;
